import { render, staticRenderFns } from "./grupos.crud.vue?vue&type=template&id=5bc35eee"
import script from "./grupos.crud.vue?vue&type=script&lang=ts"
export * from "./grupos.crud.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports